/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Move Restock Rocket notify buttons into the image badge container so they
  // appear as an overlay badge rather than below the product card.
  function moveRestockButtons() {
    document.querySelectorAll('grid-item').forEach(function(gridItem) {
      var btn = gridItem.querySelector('.restock-rocket-button-collection');
      var badgeContainer = gridItem.querySelector('.badge-box-container');
      if (btn && badgeContainer && !badgeContainer.contains(btn)) {
        btn.classList.add('badge-box');
        badgeContainer.appendChild(btn);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', moveRestockButtons);

  // Handle buttons injected asynchronously by the app
  var restockObserver = new MutationObserver(function(mutations) {
    var shouldRun = mutations.some(function(m) {
      return Array.from(m.addedNodes).some(function(n) {
        return n.nodeType === 1 && (
          (n.classList && n.classList.contains('restock-rocket-button-collection')) ||
          (n.querySelector && n.querySelector('.restock-rocket-button-collection'))
        );
      });
    });
    if (shouldRun) moveRestockButtons();
  });
  restockObserver.observe(document.body, { childList: true, subtree: true });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  // Open the Reviews accordion drawer when the Stamped badge is clicked
  var reviewsBadge = document.querySelector('.stamped-product-reviews-badge');
  if (reviewsBadge) {
    reviewsBadge.addEventListener('click', function(e) {
      e.preventDefault();
      var popups = document.querySelectorAll('popup-component');
      for (var i = 0; i < popups.length; i++) {
        var btn = popups[i].querySelector('[data-popup-open]');
        if (btn && /reviews/i.test(btn.textContent)) {
          popups[i].popupOpen();
          break;
        }
      }
    });
  }
})();


// HIDE ALBY POWERED BY
(function() {
    // 1. Process existing nodes or nested trees safely
    function hideTarget(root) {
        if (!root) return;
        
        // Hide style-based nodes immediately
        const elements = root.querySelectorAll('.powered-by');
        elements.forEach(el => {
            el.style.setProperty('display', 'none', 'important');
        });

        // Deep scan for any elements containing nested shadow roots
        root.querySelectorAll('*').forEach(node => {
            if (node.shadowRoot) {
                hideTarget(node.shadowRoot);
            }
        });
    }

    // 2. Intercept element shadow root initialization
    const originalAttachShadow = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function(options) {
        const shadowRoot = originalAttachShadow.call(this, options);
        
        // Watch this newly spawned shadow root for additions
        new MutationObserver((mutations) => {
            hideTarget(shadowRoot);
        }).observe(shadowRoot, { childList: true, subtree: true });
        
        return shadowRoot;
    };

    // 3. Keep a continuous top-level fallback check for dynamically rendered custom tags
    document.addEventListener('DOMContentLoaded', () => {
        const docObserver = new MutationObserver(() => {
            document.querySelectorAll('alby-generative-qa, alby-chat').forEach(el => {
                if (el.shadowRoot) {
                    hideTarget(el.shadowRoot);
                }
            });
        });
        
        docObserver.observe(document.documentElement, { childList: true, subtree: true });
    });
})();

/*
 * Globo Product Options — enable "Edit Options" in the Broadcast cart drawer.
 *
 * GPO only loads its cart bundle (bundle.cart.*.js) when the page type is
 * "cart". The Broadcast cart drawer renders on every other page, so we force
 * GPO to initialize its cart feature against the drawer form and re-apply the
 * edit buttons whenever the theme re-renders the drawer items.
 */
(function () {
  if (!window.GPOConfigs) return;

  var started = false;

  function gpoReady() {
    return window.GPOConfigs
      && typeof window.GPOConfigs.loadCartScripts === 'function'
      && window.GPOConfigs.page;
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function wireGpoCartDrawer() {
    if (!gpoReady()) return;

    // The /cart page already initializes GPO's cart feature natively.
    if (window.GPOConfigs.page.type === 'cart' || started) return;
    started = true;

    Promise.resolve(window.GPOConfigs.loadCartScripts()).then(function () {
      if (typeof window.GPOConfigs.onCartUpdated !== 'function') return;

      var pageConfig = window.GPOConfigs.theme
        && window.GPOConfigs.theme.cart
        && window.GPOConfigs.theme.cart.page;

      var refresh = debounce(function () {
        if (pageConfig) window.GPOConfigs.onCartUpdated(pageConfig);
        relocateGpoEditButtons();
      }, 300);

      var itemsHolder = document.querySelector('[data-items-holder]');
      if (itemsHolder) {
        new MutationObserver(function () {
          relocateGpoEditButtons();
          refresh();
        }).observe(itemsHolder, { childList: true, subtree: true });
      }

      // Catch any buttons GPO renders after we attach the observer.
      relocateGpoEditButtons();
    });
  }

  // GPO injects the "Edit Options" button inside the item's content column.
  // Move it into a full-width row at the bottom of the cart item (below the
  // quantity/remove controls) so it renders on its own line.
  function relocateGpoEditButtons() {
    document.querySelectorAll('cart-drawer [data-gpo-cart-item-key]').forEach(function (item) {
      var btn = item.querySelector('.gpo-edit-options-row .gpo-editCart');
      if (btn) return;

      btn = item.querySelector('.gpo-editCart');
      if (!btn) return;

      var row = item.querySelector('.gpo-edit-options-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'gpo-edit-options-row';
        item.appendChild(row);
      }
      row.appendChild(btn);
    });
  }

  // GPO's script is injected asynchronously; poll until the instance is ready.
  var attempts = 0;
  (function poll() {
    if (gpoReady()) {
      wireGpoCartDrawer();
      return;
    }
    if (++attempts > 200) return; // ~10s timeout
    setTimeout(poll, 50);
  })();
})();